import { useEffect } from 'react'

import Auth from 'store/auth'

import { postAxiosSingle } from 'pages/api/axios'
import { PersonaURL } from 'constants/url'

interface ISetView {
  materialId: number | string
  materialType: string
  isForceCancel?: boolean
}

const useSetView = ({ materialId, materialType, isForceCancel }: ISetView) => {
  const { isAuthorized, fakeAuth } = Auth.useAuth()

  useEffect(() => {
    const setView = async () => {
      const createQuery = () => {
        if (fakeAuth && fakeAuth !== 1) return `${PersonaURL.SET_VISIT_HISTORY}/${fakeAuth}`

        return `${PersonaURL.SET_VISIT_HISTORY}`
      }

      await postAxiosSingle(createQuery(), {}, { materialId, materialType })
    }
    isAuthorized && !isForceCancel && setView()
  }, [isAuthorized, materialId, materialType])
}

export default useSetView
